import { instanceApi } from '@/services/ProviderService'

export default {
    addPackSHip(packerCode, parcels, refDocNo, custCode, address, custName, telephone, remove_box, doc_ref){
        return instanceApi().post(`/api/packship/`, { 
            "packerCode": packerCode,
            "parcels": parcels, 
            "refDocNo": refDocNo,
            "custCode": custCode,
            "address": address,
            "custName": custName,
            "telephone": telephone,
            "parcels_remove" : remove_box,
            "doc_refs" : doc_ref
        });
    },
    getParcel(parcelId) {
        return instanceApi().get(`/api/packship/${parcelId}`).then(res => res.data);
    },
    getPickParcel(parcelId) {
        return instanceApi().get(`/api/pick/${parcelId}`).then(res => res.data);        
    },
    submitPick(parcelId, messengerCode){
        return instanceApi().put(`/api/pick/${parcelId}`, {
            "parcel_id": parcelId,
            "messenger_code": messengerCode
        }).then(res => res.data);        
    },
    fetchPickedOut(messengerCode) {
        return instanceApi().get(`/api/pickedout/${messengerCode}`).then(res => res.data);
    },
    fetchPickedOutSend(messengerCode) {
        return instanceApi().get(`/api/pickedoutsend/${messengerCode}`).then(res => res.data);        
    },
    submitPickedOutCancel(parcels) { // ยกเลิกนำพัสดุส่ง parcel_guid
        return instanceApi().post(`/api/pickedoutCancel/`, {
            "parcels": parcels
        });        
    },
    submitPickedOutCancelRoworder(roworder_list) { // ยกเลิกนำพัสดุส่ง roworder_list
        return instanceApi().post(`/api/pickedoutCancel/`, {
            "roworder_list": roworder_list
        });        
    },
    submitPickoutConfirm(parcels) {
        return instanceApi().post(`/api/pickedoutconfirm/`, {
            "parcels": parcels
        });
    },
    submitDropParcel(messengerCode, parcels, logisticcode, trackingno, imagefilestr) {
        return instanceApi().post(`/api/dropparcel`, {
            "messengerCode": messengerCode,
            "parcellist": parcels,
            "logistic_code": logisticcode,
            "tracking_no" : trackingno,
            "image" : imagefilestr
        }).then(res => res.data);
    },
    loadParcel(refDocNo) {
        return instanceApi().get(`/api/packshipload/${refDocNo}`).then(res => res.data);
    },
    feachDropticketconfirm(filter) {

        return instanceApi().get(`/api/dropticketconfirm`, {
            params: filter
        }).then(res => res.data);
    },
    dropTicketImage(guid) {
        return instanceApi().get(`/api/dropticket/${guid}`).then(res => res.data);
    },
    rejectTicker(guid, roworders) {
        return instanceApi().post(`/api/rejectticket`, {
            "image_guid": guid,
            "roworders": roworders
        }).then(res => res.data);        
    },
    approveTicker(user, roworders) {
        return instanceApi().post(`/api/approveticket`, {
            "usercode": user,
            "roworders": roworders
        }).then(res => res.data);        
    }
}